export default __webpack_public_path__ + "static/media/america.17979e49.svg";